<div class="content">
    <title>Something went wrong</title>
    <div class="logo">
        <ui-logo [small]="true"></ui-logo>
    </div>
    <div class="title">
        <h1>Something went wrong</h1>
    </div>
    <div class="text">
        <ui-label>It seems like something didn't go as expected.</ui-label>
        <div class="second-ph">
            <ui-label> If you need any assistance,<br />please contact </ui-label>
            <ui-link
                [size]="'sm'"
                href="mailto:support@bannerflow.com"
                title="Contact support">
                support&#64;bannerflow.com
            </ui-link>
        </div>
        <div class="third-ph">
            <ui-label>The Bannerflow Team</ui-label>
        </div>
    </div>
</div>
